import axiosInstance from "auth/FetchInterceptor";
import {
  GET_MISA_LATEST_SYNC_LOGS,
  GET_MISA_SYNC_LOGS,
  RETRY_MISA_SYNC_LOG
} from "constants/ApiConstant";

const ApiSyncLogService = {};

ApiSyncLogService.getAll = function (params) {
  return axiosInstance.post(GET_MISA_SYNC_LOGS, params);
};

ApiSyncLogService.getLatestSync = function (params) {
  return axiosInstance.post(GET_MISA_LATEST_SYNC_LOGS, params);
};

ApiSyncLogService.retry = function (data) {
  return axiosInstance.post(RETRY_MISA_SYNC_LOG, data);
};

export default ApiSyncLogService;